import { Component } from '@angular/core';

@Component({
  selector: 'app-new-feature',
  templateUrl: './new-feature.component.html',
  styleUrl: './new-feature.component.scss',
})
export class NewFeatureComponent {
  // optionDetails = {
  //   'New Product Launch': [
  //     'Retailer', 'Category', 'BrandFamily', 'BrandSubFamily',
  //     'BrandHouse', 'BrandVariant', 'BlendType', 'BrandPackVariant',
  //     'DiameterType', 'PackContents', 'PackType', 'PriceSector',
  //     'COGS per Stick', 'NSV_per_Stick', 'GP_per_Stick', 'Base_Price',
  //     'Distribution'
  //   ],
  //   'Pack Merger': [],
  //   'Pack De-Merger': [],
  //   'Pack Upsize/Downsize': [],
  //   'PPK Rebalancing': []
  // };
  optionDetails = {};

  selectedOption: string | null = null;
  selectedDetail: string | null = null;
  newDetailValue: string = '';
  downloaded: boolean = false;
  newDetailValues: string[] = [];

  options: string[] = [
    'New Product Launch',
    'Pack Merger',
    'Pack De-Merger',
    'Pack Upsize/Downsize',
    'PPK Rebalancing',
  ];

  onOptionSelect(option: string) {
    this.selectedOption = option;
    this.selectedDetail = null; // Reset selected detail when changing option
  }

  addNewDetail() {
    if (this.selectedOption && this.newDetailValues.length > 0) {
      this.optionDetails[this.selectedOption].push(...this.newDetailValues);
      this.newDetailValues = []; // Clear the array after adding
      this.newDetailValue = ''; // Clear the input box after adding
    }
  }

  onAddValue() {
    if (this.newDetailValue.trim()) {
      this.newDetailValues.push(this.newDetailValue.trim());
      this.newDetailValue = ''; // Clear the input box after each addition
    }
  }

  removeValue(index: number) {
    this.newDetailValues.splice(index, 1);
  }

  onDownload(): void {
    if (this.selectedOption) {
      // Logic to download a file
      console.log('Downloading for option:', this.selectedOption);
      this.downloaded = true; // Enable upload after download
      alert(`Downloaded file for ${this.selectedOption}`);
    }
  }

  onFileUpload(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      // Logic to upload the file
      console.log('Uploading file:', file.name);
      alert(`Uploaded file: ${file.name}`);
    }
  }
}
